document.addEventListener('DOMContentLoaded', function () {
  initRevelado();
  initGaleriaProducto();
  initVariantesProducto();
  initHeroFlotante();
  initCicloColores();
});

function initCicloColores() {
  var contenedor = document.querySelector('[data-pol-ciclo]');
  if (!contenedor) return;

  var fondos = contenedor.querySelectorAll('[data-pol-ciclo-fondo]');
  var productos = contenedor.querySelectorAll('[data-pol-ciclo-producto]');
  var puntos = contenedor.querySelectorAll('[data-pol-ciclo-punto]');
  var nombreEl = contenedor.querySelector('[data-pol-ciclo-nombre]');
  var total = fondos.length;
  if (total === 0) return;

  var intervalo = parseInt(contenedor.getAttribute('data-pol-ciclo-intervalo'), 10) || 4000;
  var reducirMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var actual = 0;
  var temporizador = null;

  function mostrar(indice) {
    actual = indice;
    fondos.forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-pol-ciclo-fondo') === String(indice));
    });
    productos.forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-pol-ciclo-producto') === String(indice));
    });
    puntos.forEach(function (el) {
      var esEste = el.getAttribute('data-pol-ciclo-punto') === String(indice);
      el.classList.toggle('is-active', esEste);
      if (esEste && nombreEl) nombreEl.textContent = el.getAttribute('data-nombre') || '';
    });
  }

  function siguiente() {
    mostrar((actual + 1) % total);
  }

  function reiniciarTemporizador() {
    if (temporizador) clearInterval(temporizador);
    if (reducirMovimiento) return;
    temporizador = setInterval(siguiente, intervalo);
  }

  puntos.forEach(function (boton) {
    boton.addEventListener('click', function () {
      mostrar(parseInt(boton.getAttribute('data-pol-ciclo-punto'), 10));
      reiniciarTemporizador();
    });
  });

  mostrar(0);
  reiniciarTemporizador();
}

function initHeroFlotante() {
  var visual = document.querySelector('[data-pol-flotante]');
  if (!visual) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(hover: none)').matches) return;

  var producto = visual.querySelector('[data-pol-flotante-producto]');
  var tarjetas = visual.querySelectorAll('[data-pol-flotante-card]');
  var frame = null;

  visual.addEventListener('mousemove', function (e) {
    var rect = visual.getBoundingClientRect();
    var x = (e.clientX - rect.left) / rect.width - 0.5;
    var y = (e.clientY - rect.top) / rect.height - 0.5;
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(function () {
      if (producto) producto.style.transform = 'translate(' + (x * -14) + 'px, ' + (y * -10) + 'px)';
      tarjetas.forEach(function (t, i) {
        var factor = i % 2 === 0 ? 10 : -10;
        t.style.transform = 'translate(' + (x * factor) + 'px, ' + (y * factor) + 'px)';
      });
    });
  });

  visual.addEventListener('mouseleave', function () {
    if (producto) producto.style.transform = '';
    tarjetas.forEach(function (t) { t.style.transform = ''; });
  });
}

function initRevelado() {
  var elementos = document.querySelectorAll('.pol-reveal, .pol-reveal-stagger');
  if (!elementos.length) return;
  if (!('IntersectionObserver' in window)) {
    elementos.forEach(function (el) { el.classList.add('pol-visible'); });
    return;
  }
  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add('pol-visible');
          observador.unobserve(entrada.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  elementos.forEach(function (el) { observador.observe(el); });
}

function initGaleriaProducto() {
  var principal = document.querySelector('[data-pol-galeria-principal]');
  if (!principal) return;
  var miniaturas = document.querySelectorAll('[data-pol-galeria-mini]');
  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-src');
      var srcset = mini.getAttribute('data-srcset');
      if (!src) return;
      principal.setAttribute('src', src);
      if (srcset) principal.setAttribute('srcset', srcset);
      miniaturas.forEach(function (m) { m.classList.remove('pol-activa'); });
      mini.classList.add('pol-activa');
    });
  });
}

function initVariantesProducto() {
  var forms = document.querySelectorAll('[data-pol-form-producto]');
  forms.forEach(function (form) {
    var datosEl = form.querySelector('[data-pol-variantes-json]');
    if (!datosEl) return;
    var variantes;
    try {
      variantes = JSON.parse(datosEl.textContent);
    } catch (e) {
      return;
    }
    var inputId = form.querySelector('input[name="id"]');
    var precioEl = form.querySelector('[data-pol-precio]');
    var precioTachadoEl = form.querySelector('[data-pol-precio-tachado]');
    var botonComprar = form.querySelector('[data-pol-boton-comprar]');
    var estadoStock = form.querySelector('[data-pol-estado-stock]');
    var selectores = form.querySelectorAll('[data-pol-opcion]');

    function opcionesSeleccionadas() {
      var seleccion = [];
      selectores.forEach(function (grupo) {
        var activo = grupo.querySelector('.pol-seleccionada');
        seleccion.push(activo ? activo.getAttribute('data-valor') : null);
      });
      return seleccion;
    }

    function encontrarVariante() {
      var seleccion = opcionesSeleccionadas();
      return variantes.find(function (v) {
        return v.options.every(function (op, i) { return op === seleccion[i]; });
      });
    }

    function actualizar() {
      var variante = encontrarVariante();
      if (!variante) return;
      inputId.value = variante.id;
      if (precioEl) precioEl.textContent = formatoDinero(variante.price);
      if (precioTachadoEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioTachadoEl.textContent = formatoDinero(variante.compare_at_price);
          precioTachadoEl.style.display = '';
        } else {
          precioTachadoEl.style.display = 'none';
        }
      }
      if (botonComprar) botonComprar.disabled = !variante.available;
      if (estadoStock) {
        if (variante.available) {
          estadoStock.textContent = estadoStock.getAttribute('data-texto-disponible') || 'En stock';
          estadoStock.classList.remove('pol-agotado');
          estadoStock.classList.add('pol-disponible');
        } else {
          estadoStock.textContent = estadoStock.getAttribute('data-texto-agotado') || 'Agotado';
          estadoStock.classList.remove('pol-disponible');
          estadoStock.classList.add('pol-agotado');
        }
      }
    }

    function formatoDinero(centavos) {
      var valor = (centavos / 100).toFixed(2).replace('.', ',');
      return valor + ' ' + (form.getAttribute('data-moneda') || '€');
    }

    selectores.forEach(function (grupo) {
      var valores = grupo.querySelectorAll('[data-valor]');
      valores.forEach(function (valorBtn) {
        valorBtn.addEventListener('click', function () {
          valores.forEach(function (v) { v.classList.remove('pol-seleccionada'); });
          valorBtn.classList.add('pol-seleccionada');
          actualizar();
        });
      });
    });
  });
}
